/**
 * useSourcesListScreen.js
 * -----------------------
 * Headless Hook for Lead / Inquiry Source Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterList } from '../../common/useMasterList';
import * as sourcesApi from '../api/sourcesApi';
import { useExportJob } from '../../../../hooks/useExportJob';
import { executePrintReport } from '../../../../utils/printReportUtil';

export function useSourcesListScreen() {
  const master = useMasterList({
    entityName: 'Source',
    apiClient: sourcesApi.sourcesClient,
    fetchList: sourcesApi.listSources,
    archiveItem: sourcesApi.archiveSource,
    deleteItem: sourcesApi.deleteSource,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'sources',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    } else if (toolKey === 'print') {
      executePrintReport({
        title: 'Lead & Inquiry Source Registry',
        subtitle: 'Enterprise Marketing & Acquisition Channels',
        columns: [
          { header: 'ID', accessor: 'id' },
          { header: 'Source Name', accessor: 'name' },
          { header: 'Abbreviation / Code', accessor: 'short_name' },
          { header: 'Status', accessor: 'status' },
          { header: 'Created Date', accessor: 'created_on' },
        ],
        rows: master.state.rows || [],
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
